export enum EAgencyActions {
    GET_AGENCY = 'GET_AGENCY'
}
